export default {
  "hierarchy": {
    "hollow": [
      "dateTimePicker-hollow"
    ],
    "test": [
      "dateTimePicker-test"
    ],
    "timeOnly": [
      "dateTimePicker-timeOnly"
    ],
    "contractForm": [
      "dateTimePicker-contractForm"
    ]
  },
  "props": {
    "default": {},
    "hollow": {},
    "test": {},
    "timeOnly": {},
    "contractForm": {}
  }
}